import { cn } from '@/lib/utils'

type Props = {
  actual: number
  expected?: number
  className?: string
  mode?: 'planned' | 'resolved'
  setupSize?: number
  ignored?: number
  disabled?: boolean
}

const AssignmentExpectedEntitiesCount = ({
  actual,
  expected,
  className,
  mode = 'planned',
  setupSize,
  ignored = 0,
  disabled = false,
}: Props) => {
  if (typeof expected !== 'number') return null
  const isSuccess = disabled
    ? true
    : mode === 'resolved'
    ? actual + ignored >= expected ||
      (typeof setupSize === 'number' && setupSize < expected)
    : actual <= expected
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 text-sm text-muted-foreground',
        className,
      )}
    >
      <span className='h-1 w-1 rounded-full bg-current opacity-60' />
      <span className='inline-flex items-center gap-0.5'>
        <span
          className={cn(
            'font-medium',
            disabled
              ? 'text-muted-foreground'
              : isSuccess
              ? 'text-success-foreground'
              : 'text-warning-foreground',
          )}
        >
          {disabled ? '?' : actual}
        </span>
        <span>/</span>
        <span>{expected}</span>
      </span>
    </span>
  )
}

export default AssignmentExpectedEntitiesCount
